import { defineAdapter } from '@loop-coffee/commerce-contracts';

// Simulated shipping until the shipping-fulfillment epic plugs a real one into the same slot. It
// goes through the Store API; no carrier SDK is loaded in the browser. Payment lives in ./payments.
export function createMockShippingAdapter(client) {
    return defineAdapter('shipping', {
        id: 'store-api-manual',
        label: 'Envio simulado',
        async listOptions(cart) {
            const options = await client.listShippingOptions(cart.id);
            return options.map((option) => ({
                id: option.id,
                label: option.name,
                amount: option.calculated_price?.calculated_amount ?? option.amount,
            }));
        },
        select(cart, optionId) {
            return client.addShippingMethod(cart.id, optionId);
        },
    });
}
